function l(n){return n!=null}export{l as a};
